module.exports = __webpack_public_path__ + "img/transfer2.a91795af.jpg";